import { ApiBlobGetRequest, ApiGetRequest } from '../../../api';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Report - TEUS',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/report',
      },
      {
        text: 'Report - TEUS',
        href: '/adm/opr/report/teus',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_principle',
    sortDesc: true,
    fields: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'stock_20',
        label: 'Stock 20',
      },
      {
        key: 'stock_21',
        label: 'Stock 21',
      },
      {
        key: 'stock_40',
        label: 'Stock 40',
      },
      {
        key: 'stock_41',
        label: 'Stock 41',
      },
      {
        key: 'stock_45',
        label: 'Stock 45',
      },
      {
        key: 'total_teus',
        label: 'Total',
      },
    ],
    field_move: [
      {
        key: 'principle',
        label: 'Principle',
      },
      {
        key: 'in_20',
        label: 'IN 20',
      },
      {
        key: 'in_21',
        label: 'IN 21',
      },
      {
        key: 'in_40',
        label: 'IN 40',
      },
      {
        key: 'in_41',
        label: 'IN 41',
      },
      {
        key: 'in_45',
        label: 'IN 45',
      },
      {
        key: 'in_total',
        label: 'TEUS IN',
      },
      {
        key: 'out_20',
        label: 'OUT 20',
      },
      {
        key: 'out_21',
        label: 'OUT 21',
      },
      {
        key: 'out_40',
        label: 'OUT 40',
      },
      {
        key: 'out_41',
        label: 'OUT 41',
      },
      {
        key: 'out_45',
        label: 'OUT 45',
      },
      {
        key: 'out_total',
        label: 'TEUS OUT',
      },
      {
        key: 'stok_total',
        label: 'STOK',
      },
    ],
    footer: [
      {
        name: 'f_principle',
        key: 'principle',
        label: 'TOTAL',
        sortable: false,
      },
      {
        name: 'f_stock_20',
        key: 'stock_20',
        label: 'SUM 20',
        sortable: false,
      },
    ],
    detail: false,
    form: {
      id_principle: '',
      principle_code: '',
      principle_name: '',
      date: [],
      tipe_report: 1,
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  reportTeus(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getStockTeus({ commit, state, dispatch }, payload = null) {
    commit('reportTeus', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle:
        data.form && data.form.id_principle ? data.form.id_principle : '',
      start_date:
        data.form.date && data.form.date.length
          ? moment(data.form.date[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        data.form.date && data.form.date.length
          ? moment(data.form.date[1]).format('YYYY-MM-DD')
          : '',
      export: payload && payload.export ? 1 : '',
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`opr/report/stock-teus`, params);
      commit('reportTeus', {
        loading: false,
      });
      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_stock_teus.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`opr/report/stock-teus`, params);
      if (result.error) {
        showNotif(dispatch, {
          message: result.message,
          type: result.error ? 'error' : 'success',
        });

        return false;
      } else {
        commit('reportTeus', {
          items: result.data.object || [],
          total: result.data.total || 0,
          loading: false,
        });

        return true;
      }
    }
  },

  async getMoveInOut({ commit, state, dispatch }, payload = null) {
    commit('reportTeus', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle:
        data.form && data.form.id_principle ? data.form.id_principle : '',
      start_date:
        data.form.date && data.form.date.length
          ? moment(data.form.date[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        data.form.date && data.form.date.length
          ? moment(data.form.date[1]).format('YYYY-MM-DD')
          : '',
      export: payload && payload.export ? 1 : '',
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`opr/report/move-in-out`, params);
      commit('reportTeus', {
        loading: false,
      });
      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_move_in_out.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`opr/report/move-in-out`, params);
      if (result.error) {
        showNotif(dispatch, {
          message: result.message,
          type: result.error ? 'error' : 'success',
        });

        return false;
      } else {
        commit('reportTeus', {
          items: result.data.object || [],
          total: result.data.total || 0,
          loading: false,
        });

        return true;
      }
    }
  },
};
